<template>
  <div class="close-modal">
    <!-- <el-dialog title="提示" :visible.sync="closeModalShow" width="400px" class="closeModal">
      <div class="title">确认关闭引导吗？</div>
      <div class="text">
        关闭后，此引导将不再提示，请谨慎操作!
      </div>
      <span slot="footer" style="text-align:center;">
        <el-button @click="closeModalShow = false">取 消</el-button>
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  name: 'close-modal',
  data() {
    return {
      closeModalShow: false,
    }
  },
  methods: {
    show() {
      // this.closeModalShow = true
      this.$confirm(
        this.$t('user-guidance::data::close_tip'),
        this.$t('system::common::dialog::change_merchant_tooltip'),
        {
          confirmButtonText: this.$t('system::common::btn::confirm'),
          cancelButtonText: this.$t('system::common::btn::cancel'),
          closeOnClickModal: false,
        }
      )
        .then(() => {
          this.handleClose()
        })
        .catch(() => {})
    },
    close() {
      this.closeModalShow = false
    },
    async handleClose() {
      // this.closeModalShow = false
      this.$emit('closeGuidance')
      let list = await this.getBindData()
      this.buried(list)
    },
    async getBindData() {
      let data = this.$store.state.user.hasBindData
      if (!data) {
        await this.$store.dispatch('getBindData')
      }
      data = this.$store.state.user.hasBindData
      let list = []
      for (let key in data) {
        if (key === 'isExistShop') {
          if (data[key]) {
            list.push('授权店铺')
          }
        } else if (key === 'isExistAds') {
          if (data[key]) {
            list.push('设置Facebook账号')
          }
        } else if (key === 'isExistStaff') {
          if (data[key]) {
            list.push('员工管理')
          }
        } else if (key === 'isExistRole') {
          if (data[key]) {
            list.push('角色管理')
          }
        } else if (key === 'isExistBoard') {
          if (data[key]) {
            list.push('看板管理')
          }
        }
      }
      return list
    },
    buried(list) {
      let str = ''
      if (list.length) {
        str = list.join(',')
      }
      this.$store.dispatch('buried', { event: 'CloseGuide', setupFinish: str })
    },
  },
}
</script>

<style lang="scss" scoped>
.closeModal {
  text-align: center;
  .title {
    font-weight: bold;
    font-size: 20px;
    color: #010517;
    margin-bottom: 20px;
  }
  .text {
    color: #ccc;
  }
}

::v-deep {
  .el-dialog__footer {
    text-align: center;
  }
}
</style>
